<form class="full-width">
  <mat-form-field class="full-width" [floatLabel]="emailInvitations.length ? 'always' : 'auto'">
    <mat-label>Emails</mat-label>
    <mat-chip-grid #chipList>
      <mat-chip-option
        *ngFor="let email of emailInvitations"
        selectable="true"
        removable="true"
        (removed)="remove(email, emailInvitations)"
      >
        {{ email }}
        <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
      </mat-chip-option>
      <input
        #mailInput
        (paste)="pasteEvent($event)"
        placeholder="Enter emails or paste one or more to send"
        [formControl]="myControl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="add($event)"
      />
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)"> </mat-autocomplete>
    <mat-hint *ngIf="myControl.hasError('email')" i18n><span class="mat-error">Enter a valid email</span></mat-hint>
  </mat-form-field>
</form>
